/*
 * Copyright (c) 2019. Unconventional Software Corporation
 */

import { Injectable } from '@angular/core';
import {AngularFireDatabase} from "angularfire2/database";
import {DataReference} from "../../shared/DataReference";
import {HelpTopic} from "./HelpTopic";
import {NavController} from "ionic-angular";
import {PageRefs} from "../../shared/PageRefs";


@Injectable()
export class HelpProvider {

  private static readonly CONTACT_URL: string = 'http://stagesprite.com/contact-informaton';

  static getContactUrl(): string {
    return HelpProvider.CONTACT_URL;
  }

  constructor(private af: AngularFireDatabase) {

  }

  getHelpTopics(type: string) {
    return this.af.list(DataReference.getHelpTopicsRef(type)).snapshotChanges()
      .map(snaps => HelpTopic.fromSnapshots(snaps)
        .sort((a,b) => {
          return a.order < b.order ? -1 : a.order == b.order ? 0 : 1;
        })
      );
  }

  getContactUsUrl() : Promise<string> {
    return new Promise<string>((resolve, reject) => {

      this.af.database.ref(DataReference.getContactUsUrl('en'))
        .once(DataReference.Value, snapshot => {
          if (snapshot.exists()) {
            resolve(snapshot.val());
          } else {
            resolve(HelpProvider.CONTACT_URL);
          }
        }, err => {
          console.error(err);
          resolve(HelpProvider.CONTACT_URL);
        });
    });
  }

  static navigateToHelp(nav: NavController, topic: string) {
    let data = {};
    data[PageRefs.help.params.topic] = topic;
    nav.push(PageRefs.help.name, data);
  }


}



// WEBPACK FOOTER //
// ./src/providers/help/help.ts